module.exports = __webpack_public_path__ + "img/archive-hero.6c9d5ac4.webp";